


























import { defineComponent, useContext } from "@nuxtjs/composition-api"

import { downloadFile } from "@/utils/misc"

export default defineComponent({
  name: "ImagePreview",
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    isAvatar: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      default: undefined,
    },
    fileName: {
      type: String,
      default: "download",
    },
    showDownloadButton: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const { app } = useContext()

    const imageUrlAvatar = () => {
      let url = props.imageUrl
      if (props.isAvatar) {
        url =
          app.$config.API_BASE_URL +
          app.$enums.ApiPaths.GET_AVATAR.replace(
            ":userId",
            props.userId.toString(),
          ).replace("/rs:auto:WIDTH:HEIGHT", "")
      }
      return url
    }

    return {
      downloadFile,
      imageUrlAvatar,
    }
  },
})
